<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()">Satisfaction</ion-title>
        <ion-buttons slot="end">
            <ion-buttons slot="end">
                <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
  
<ion-content>
    <ion-list>
        <ion-list-header color="secondary">
            We need your feedback! (Step 1 of 2)
        </ion-list-header>

        <ion-item-divider color="tertiary">
            Our Intention and Mission Statement Is Simple and Threefold:
        </ion-item-divider>
        <ion-item class="ion-no-padding">
            <ion-label class="ion-text-wrap">
                <ol>
                    <li>Create a product that allows you to manage your shuttle department more efficiently, 
                            aids you in endearing your customers to you and allows you to generate revenue.</li>
                    <li>Provide customer support that knocks your socks off. Our intention will always be to
                            go above and beyond reasonable support.</li>
                    <li>Turn each of our customers into a raving fan.</li>
                </ol>            
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">We Need Your Honest Feedback...</ion-item-divider>
        <ion-item>
            <ion-label class="ion-text-wrap">
                Ultimately the three questions on the next page are trying to assess whether you feel we are 
                accomplishing our mission statement and we treated you in a manner that is worthy of your 
                loyalty.<br /><br />
                <strong>Please click the Next button and answer the 3 questions.</strong>
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled (click)="onNextClick()" title="Next">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
